import React from 'react';

const styleMain = {
    position: 'absolute',
    margin: 'auto',
    pointerEvent: 'none',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: '5%',
    zIndex: 1000
}

const Spinner = (props) => {
    const spinPosition = props.fixed ? 'fixed' : 'absolute';
    return (
        <div className="d-flex justify-content-center" style={{ ...styleMain, position: spinPosition }}>
            <div className="spinner-border" role="status" style={{ color: '#212529', borderRightColor: '#1890ff' }}>
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    )
}

export default Spinner;

